import type { Raster } from '@repo/warp-engine';

/**
 * RGBA 래스터를 PNG blob URL 로 만든다(브라우저 전용). 다 쓴 URL 은 URL.revokeObjectURL 로 풀어야 한다.
 * 캔버스 2D 컨텍스트나 PNG 를 만들지 못하면 Error 로 거부한다.
 */
export const rasterToObjectUrl = async (raster: Raster): Promise<string> => {
  const canvas = document.createElement('canvas');
  canvas.width = raster.width;
  canvas.height = raster.height;
  const context = canvas.getContext('2d');
  if (context === null) throw new Error('캔버스 2D 컨텍스트를 만들 수 없습니다.');
  const imageData = context.createImageData(raster.width, raster.height);
  imageData.data.set(raster.data);
  context.putImageData(imageData, 0, 0);
  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'));
  if (blob === null) throw new Error('미리보기 PNG 를 만들 수 없습니다.');
  return URL.createObjectURL(blob);
};
